import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/components/AuthProvider';
import { usePermissions } from '@/hooks/usePermissions';
import { LoadingFallback } from '@/components/LoadingFallback';
import { AVAILABLE_TABS } from '@/config/permissions';

export const SmartRedirect = () => {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return <LoadingFallback />;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Always redirect to dashboard if authenticated
  return <Navigate to="/dashboard" replace />;
};